export var SnapshotSortField;
(function (SnapshotSortField) {
    SnapshotSortField["SNAPSHOT_SORT_POINT_IN_TIME"] = "pointInTime";
})(SnapshotSortField || (SnapshotSortField = {}));
